// extracted by mini-css-extract-plugin
module.exports = {"container":"PricingStatusCard_container__1mOXW"};